(function($) {
	function initShowMore() {
		var showMoreLinks = $(".show-more__link");

		if (showMoreLinks.length > 0) {
			showMoreLinks.off('click').on("click", function(event) {
				event.preventDefault();
				$(this)
					.parents(".casestudy-details-bar")
					.toggleClass("expanded");
				if ($(this).parents(".casestudy-details-bar").hasClass("expanded")) {
					$(this).find('.text').text('Show less');
					$(this).find('.text').addClass('open');
				} else {
					$(this).find('.text').text('Show more');
					$(this).find('.text').removeClass('open');
				}
			});
		} else {
			// If no links found, try again after a short delay
			setTimeout(initShowMore, 100);
		}
	}

	// Wait for DOM to be ready
	$(document).ready(function() {
		initShowMore();
	});

	// Also try after a delay in case DOM elements are added dynamically
	setTimeout(initShowMore, 500);
})(jQuery);
